export default function baseAvatarStyles({
  textColor,
  subTextColor
}) {
  
  let jss = {
    '& .avatar-text .text': {
      fontSize: '1em',
      color: textColor
    },

     '& .avatar-text .subtext': {
      fontSize: '1em',
      color: subTextColor
    }
  }

  return jss
}
